import { useState } from "react";
import { faqs } from "@/mocks/guatrend";

export default function FaqSection() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section id="faq" className="w-full bg-background-100 py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1fr_1.6fr]">
          <div>
            <p className="text-sm font-medium text-primary-600 whitespace-nowrap">FAQs</p>
            <h2 className="font-display mt-2 text-2xl text-foreground-900 md:text-4xl">吃瓜不迷路，常见问题看这里</h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              关于评分来源、更新频率与投稿方式，我们一次说清楚。若还有疑问，欢迎在下方投稿表单里留言，我们会尽快回复。
            </p>
            <a
              href="#submit"
              className="mt-6 inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-accent-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-accent-600"
            >
              <i className="ri-chat-3-line"></i>
              我想咨询更多
            </a>
          </div>

          <div className="divide-y divide-background-200 overflow-hidden rounded-2xl border border-background-200 bg-background-50">
            {faqs.map((f, idx) => {
              const isOpen = open === idx;
              return (
                <div key={f.q}>
                  <button
                    type="button"
                    aria-expanded={isOpen}
                    onClick={() => setOpen(isOpen ? -1 : idx)}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left md:px-6 md:py-5"
                  >
                    <span className="text-sm font-semibold text-foreground-900 md:text-base">{f.q}</span>
                    <span
                      className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-colors ${
                        isOpen ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-600"
                      }`}
                    >
                      <i className={`${isOpen ? "ri-subtract-line" : "ri-add-line"}`}></i>
                    </span>
                  </button>
                  {isOpen && (
                    <div className="px-5 pb-5 md:px-6">
                      <p className="border-l-2 border-primary-300 pl-4 text-sm leading-relaxed text-foreground-600">
                        {f.a}
                      </p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}